import React from "react";
import { Link } from "react-router-dom";
import { Box, Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { ROUTES } from "../routes";
import { useTranslation } from "react-i18next";
import PromiseTrackingMask from "./PromiseTrackingMask";
import OfflineFormsDownload from "./OfflineFormsDownload";

function resolveCardHeight() {
  const windowWidth = window.innerWidth;
  if (windowWidth < 1120 && windowWidth > 900) {
    return 230;
  }
  return 150;
}

const Navigation: React.FC = () => {
  const { t } = useTranslation();

  const pages = [
    { name: t("forms.mandatoryOccurNotification.title"), path: ROUTES.MANDATORY_OCCURRENCE_FORM },
    { name: t("forms.para.title"), path: ROUTES.SKYDIVING_FORM },
    { name: t("nav.annex1"), path: ROUTES.ANNEX_1_AIRCRAFT },
    { name: t("forms.voluntaryOccurNotification.title"), path: ROUTES.VOLUNTARY_OCCURRENCE_FORM },
    { name: t("forms.eccairsPdf.title"), path: ROUTES.ECCAIRS_PDF_UPLOAD_FORM }
  ];

  return (
    <Box marginX={2}>
      <PromiseTrackingMask area="home" />
      <Box textAlign="center" my={4}>
        <Typography variant="h4" gutterBottom>
          {t("nav.systemReporting")}
        </Typography>
      </Box>

      <Grid container spacing={3} justifyContent="center">
        {pages.map((page) => (
          <Grid item xs={12} sm={6} md={3} key={page.name}>
            <Card>
              <CardActionArea component={Link} to={page.path}>
                <CardContent
                  sx={{
                    textAlign: "center",
                    minHeight: resolveCardHeight(),
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    {page.name}
                  </Typography>
                  <Typography variant="body2">
                    {t("nav.navigateTo")} {page.name}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box mt={2} mb={2}>
        <OfflineFormsDownload />
      </Box>
    </Box>
  );
};

export default Navigation;
